import { API_NftDetails } from 'shared';
import { IUseFreeNft } from '../../../hooks/freeNft/useFreeNft';
import { SetState } from '../../../interfaces/SetState';

export enum MarketNftStatuses {
  UNAVAILABLE,
  MINTED,
  FAILED,
  PENDING,
  AVAILABLE
}

export const getNftMarketStatus = (nft: API_NftDetails): MarketNftStatuses => {
  if (nft.belongsToSelf) {
    if (nft.minted) {
      return MarketNftStatuses.MINTED;
    }
    if (nft.failed) {
      return MarketNftStatuses.FAILED;
    }
    if (nft.pending) {
      return MarketNftStatuses.PENDING;
    }
  }
  if (nft.minted || nft.pending) {
    return MarketNftStatuses.UNAVAILABLE;
  }
  return MarketNftStatuses.AVAILABLE;
};

export type NftUpdate = (callback: () => void) => void;

export interface MarketPageModeProps {
  status: MarketNftStatuses;
  nft: API_NftDetails;
  freeNft: IUseFreeNft;
  actionLoading: boolean;
  setActionLoading: SetState<boolean>;
}
